/**
 * "The sync settings just changed" — a one-line channel from the auto-sync
 * dialog to the sidebar's sync indicator.
 *
 * The indicator polls a minute apart, which is right for a status that moves
 * on its own but wrong for one the operator has just changed by hand: a
 * switch that takes up to a minute to show reads as a switch that did not
 * register. The dialog lives inside the Connections page and the indicator
 * inside the rail, with the whole shell between them, so a callback would
 * have to be threaded through three components that have no other reason to
 * know about either. A module-level channel is the smaller thing.
 *
 * Deliberately not `connectionVersion`: that means "the active connection
 * changed" and re-fetches the user, the credentials, the health check and the
 * skin. Turning auto-send off is none of those.
 */
type Listener = () => void;

const listeners = new Set<Listener>();

/** Call after the auto-sync schedule or the cadence has been saved. */
export function notifySyncConfigChanged(): void {
    for (const listener of [...listeners]) listener();
}

/** Returns the unsubscribe function, for an effect's cleanup. */
export function onSyncConfigChanged(listener: Listener): () => void {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}
